import {
  ImportDisplayStatus,
  ImportReportCounts,
  ProductImportReportStatus,
} from './product-import-report-types';

// Layer the UI-only warning state over the backend status: a run that succeeded but
// logged warnings becomes 'WARNING'; everything else passes straight through. This is
// the single place the success-with-warnings rule lives. See
// docs/adr/0001-warning-state-is-ui-derived.md.
export const toDisplayStatus = (
  status: ProductImportReportStatus | null,
  counts: ImportReportCounts | null
): ImportDisplayStatus => {
  if (status === ProductImportReportStatus.SUCCESSFUL && (counts?.warningCount ?? 0) > 0) {
    return 'WARNING';
  }
  return status;
};

// Dutch label for a display status. `null` means the area has never run.
export const reportStatusLabel = (status: ImportDisplayStatus): string => {
  switch (status) {
    case ProductImportReportStatus.SUCCESSFUL:
      return 'Geslaagd';
    case 'WARNING':
      return 'Waarschuwingen';
    case ProductImportReportStatus.FUNCTIONAL_FAILURE:
      return 'Functionele fout';
    case ProductImportReportStatus.TECHNICAL_FAILURE:
      return 'Technische fout';
    case ProductImportReportStatus.RUNNING:
      return 'Bezig';
    default:
      return 'Nog niet uitgevoerd';
  }
};

// Bootstrap badge classes (+ the shared custom classes in styles.scss) for a status.
export const reportStatusBadgeClass = (status: ImportDisplayStatus): string => {
  switch (status) {
    case ProductImportReportStatus.SUCCESSFUL:
      return 'badge bg-success';
    case 'WARNING':
      return 'badge badge-warnings';
    case ProductImportReportStatus.FUNCTIONAL_FAILURE:
      return 'badge bg-danger';
    case ProductImportReportStatus.TECHNICAL_FAILURE:
      return 'badge badge-technical-failure';
    case ProductImportReportStatus.RUNNING:
      return 'badge bg-warning text-dark badge-running';
    default:
      return 'badge badge-never-run';
  }
};

// Border colour for a board tile. Mirrors the badge colour (technical failure in
// the same darker red as its badge, warnings in the same orange, defined in styles.scss).
export const reportStatusBorderClass = (status: ImportDisplayStatus): string => {
  switch (status) {
    case ProductImportReportStatus.SUCCESSFUL:
      return 'border-success';
    case 'WARNING':
      return 'border-warnings';
    case ProductImportReportStatus.FUNCTIONAL_FAILURE:
      return 'border-danger';
    case ProductImportReportStatus.TECHNICAL_FAILURE:
      return 'border-technical-failure';
    case ProductImportReportStatus.RUNNING:
      return 'border-warning';
    default:
      return 'border-never-run';
  }
};
